export default {
  macos: "Mac",
  enrollYourDevice: "Enroll your device",
  pageDescription: `This page helps you to enroll devices to your organization.`,
  chooseAnotherEnrollmentPlan: `Choose enrollment method`,
  modernMDMEnrollment: `Modern MDM enrollment (recommended)`,
  modernMDMEnrollmentDescription: `Select and install the appropriate agents for your OS to enroll your
  device.`,
  wereNoticiedYouUsed: `We’ve noticed that you’re using a`,
  seeAllOperatingSystem: `See All Operating Systems`,
  macDevices: "mac Devices",
  windows: "Windows",
  enrollWithAgentless: `Enroll with Agent-less method`,
  enrollWithAgentlessDescription: `Compared to Modern enrollment, this method is less restrictive, allows
  only MDM profile-based device enrollment, and provides fewer options.`,
  enrolledDeviceSubtitle:
    "Enroll your devices on Trio and assign them to different users.",
  chooseAnotherWayToEnroll: `Enroll this device in your panel without installing Trio's agent, leading to fewer available features.`,
  // Update
  iPad: "iPad",
  iPhone: "iPhone",
  android: "Android",
  ios_enrollment_note:
    "Note that enrolling iPhone and iPad devices requires downloading and installing a profile on the device, and then installing the agent to enroll your devices.",
  enter_pairing_code:
    "Please enter the pairing code you received from your company.",
  enroll_with_agent_less: "Enroll with agent-less method",
  install_your_profile: "install your profile",
  scan_below_qr_code: "Scan the QR code below to download the profile",
  ios_install_profile_guid_title: "How to install profiles on iPhone and iPad",
  ios_install_profile_guid_desc:
    "After you download a profile, you’ll see the message Profile Downloaded or Enroll in [organization name] To install the profile, follow these steps:",
  ios_install_profile_guid_steps: [
    "Open the Settings app.",
    "Tap Profile Downloaded or Enroll in [organization name].",
    "Tap Install in the upper-right corner, then follow the onscreen instructions.",
  ],
  ios_install_profile_guid_subtitle:
    "You can only have one profile ready to install at a time. For example, if you download a profile and don’t install it, and then download a second profile, only the second profile is available to be installed.",
  watch_ios_youtube: "Watch how to install profile on iPhone and iPad",
  download_macos_profile: "Download Mac agent installer",
  download_windows_profile: "Download Windows profile",
  select_and_download:
    "Select and download the appropriate agents based on your OS",
};
